<template>
    <div>
        <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" :id="'actionSheetIconed_' + cargo">
            <div class="offcanvas-header background-TEAL">
                <h5 class="offcanvas-title text-light">مسیریابی (تا مرکز شهر)</h5>
                <a href="#" id="off" class="offcanvas-close" style="display: none"
                    data-bs-dismiss="offcanvas">
                    <ion-icon name="close-outline"></ion-icon>
                </a>
            </div>

            <div class="offcanvas-body" v-if="fromLat">
                <ul class="action-button-list">
                    <li>
                        <a v-bind:href="'geo:' +
                            fromLat +
                            ',' +
                            fromLong
                            " class="btn btn-list" target="_blank">
                            <span class="text-black">
                                <ion-icon name="map-outline"></ion-icon>
                                تا بارگیری
                            </span>
                        </a>
                    </li>
                    <li>
                        <a v-bind:href="'geo:' + toLat + ',' + toLong" class="btn btn-list">
                            <span class="text-black">
                                <ion-icon name="map-outline"></ion-icon>
                                تا تخلیه
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="offcanvas-body" v-else>
                <p class="text-center">لطفا منتظر باشید...</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'routing',
    props: [
    'cargo',
    'fromLat',
    'fromLong',
    'toLat',
    'toLong'
]
}
</script>
<style></style>